import { useQuery, UseQueryOptions } from 'react-query';
import type { TLocations } from 'src/types';
import { httpClient } from 'src/utils/HttpClients';
import type { AxiosError } from 'axios';
import get from 'lodash/get';

type TProps = {
    withDeleted?: boolean;
};

export const useGetLocations = (
    props: TProps | void,
    options: Partial<
        UseQueryOptions<
            { data: TLocations },
            AxiosError,
            { data: TLocations },
            ['locations', TProps]
        >
    > | void
) => {
    const withDeleted: boolean = get(props, 'withDeleted', false);

    const queryFn = async () => {
        const response = await httpClient.get<{ data: TLocations }>('/locations');
        let data = get(response, 'data.data', []) as TLocations;
        if (!withDeleted) {
            data = data.filter((location) => !location.deleted);
        }
        return { data };
    };

    return useQuery(['locations', props ?? {}], queryFn, {
        keepPreviousData: false,
        ...options,
    });
};
